import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
const _ExploreCollection = Fold.compose(Optics._Col2Items, Optics._ColItem2Channel);
const _Route = Fold.compose(_ExploreCollection, Res._Rel("routes"), Res._Response(), Fold._each(), Lens.path("attributes", "url"));
const _AlternateId = Fold.compose(_ExploreCollection, Res._Response(), Lens.path("attributes", "alternateId"));
const _ExploreLiveChannelImages = Fold.compose(_ExploreCollection, Res._Rel("images"), Optics._ImagesOfKind("logo"), Res._Response(), Lens.prop("attributes"));
const _ExploreShowImages = Fold.compose(_ExploreCollection, Res._Rel("images"), Optics._ImagesOfKind("poster"), Res._Response(), Lens.prop("attributes"));
export const _ExploreLiveChannelLists = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Fold.liftM((liveChannelImages, route, channelTitle) => ({
    liveChannelImages,
    route,
    channelTitle,
}), _ExploreLiveChannelImages, _Route, _AlternateId));
export const _ExploreShowLists = Fold.compose(Optics._Col2Items, Optics._ColItem2Collection, Fold.liftM((exploreShowsImages, route, channelTitle) => ({
    exploreShowsImages,
    route,
    channelTitle,
}), _ExploreShowImages, _Route, _AlternateId));

